import type { CSSProperties } from "react";
import { Handle, Position, type NodeProps } from "@xyflow/react";
import type { DailyNode } from "./types";

export function DailyTextNode({ id, data, selected }: NodeProps<DailyNode>) {
  return (
    <div
      style={{
        ...styles.node,
        ...(selected ? styles.nodeSelected : {}),
      }}
    >
      <Handle type="target" position={Position.Left} />
      <div className="daily-node-drag-handle" style={styles.nodeDragHandle}>
        Move
      </div>
      <textarea
        className="nodrag"
        value={data.text}
        onChange={(event) => data.onTextChange?.(id, event.target.value)}
        placeholder="Write anything..."
        style={styles.nodeTextArea}
      />
      <Handle type="source" position={Position.Right} />
    </div>
  );
}

const styles = {
  node: {
    width: "220px",
    minHeight: "120px",
    border: "1px solid var(--border)",
    borderRadius: "8px",
    background: "var(--bg)",
    boxShadow: "var(--shadow)",
    overflow: "hidden",
  },
  nodeSelected: {
    borderColor: "var(--accent-border)",
  },
  nodeDragHandle: {
    height: "28px",
    display: "flex",
    alignItems: "center",
    padding: "0 10px",
    borderBottom: "1px solid var(--border)",
    color: "var(--text)",
    background: "var(--social-bg)",
    fontSize: "12px",
    cursor: "grab",
    userSelect: "none",
  },
  nodeTextArea: {
    width: "100%",
    minHeight: "104px",
    border: 0,
    background: "transparent",
    color: "var(--text-h)",
    padding: "12px",
    boxSizing: "border-box",
    resize: "both",
    font: "inherit",
    fontSize: "14px",
    outline: "none",
  },
} satisfies Record<string, CSSProperties>;
